import {Component, OnDestroy, OnInit} from '@angular/core';
import {CardComponent} from "../../components/ui/card/card.component";
import {InputComponent} from "../../components/ui/input/input.component";
import {SelectComponent} from "../../components/ui/select/select.component";
import {Column, TableComponent} from "../../components/ui/table/table.component";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {combineLatest, debounceTime, map, shareReplay, Subject, Subscription, switchMap} from "rxjs";
import {Sort} from "../../models/sort";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpParams} from "@angular/common/http";
import {SortHelper} from "../../utils/sort-helper";
import {ProjectService} from "../../services/project.service";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'app-projects-list',
  standalone: true,
  imports: [
    CardComponent,
    InputComponent,
    SelectComponent,
    TableComponent,
    TranslateModule,
    ReactiveFormsModule,
    AsyncPipe
  ],
  templateUrl: './projects-list.component.html',
  styleUrl: './projects-list.component.scss'
})
export class ProjectsListComponent implements OnInit, OnDestroy {
  public columns: Column[] = [
    { name: 'name', label: 'page.projects.list.name' },
    { name: 'description', label: 'page.projects.list.description' },
    { name: 'statusDisplay', label: 'page.projects.list.status' },
    { name: 'createdAt', label: 'page.projects.list.created', date: true },
  ];

  public data$ = this.route.queryParams.pipe(
    switchMap((queryParams) => {
      let requestParams = new HttpParams();

      if (queryParams['search']) {
        requestParams = requestParams.set('search', queryParams['search']);
      }

      let page = 0;
      if (queryParams['page']) {
        page = +queryParams['page'];
      }

      let sort: Sort | undefined = undefined;
      if (queryParams['sort']) {
        sort = SortHelper.convertStringToSort(queryParams['sort']);
      }

      return this.projectService.list(page, sort, requestParams);
    }),
    map(response => ({
      ...response,
      content: response.content.map(project => ({
        ...project,
        link: `/panel/projects/detail/${project.id}`,
        statusDisplay: project.status === 'archived' 
          ? `🗃️ ${this.translateService.instant(`project.status.${project.status}`)}` 
          : this.translateService.instant(`project.status.${project.status}`),
        isArchived: project.status === 'archived',
      })),
    })),
    shareReplay(1),
  );
  sortOptions = this.columns.map(column => ({ value: column.name, labelKey: column.label }));
  sortControl = new FormControl(this.route.snapshot.queryParams['sort'] ?? this.sortOptions[0].value);
  searchControl = new FormControl(this.route.snapshot.queryParams['search'] ?? '');
  subscriptions: Subscription[] = [];

  constructor(private route: ActivatedRoute, private projectService: ProjectService, private router: Router, private translateService: TranslateService) {

  }

  changePage(page: number) {
    this.router.navigate([], {
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
  }

  ngOnInit() {
    this.subscriptions.push(
      this.sortControl.valueChanges.subscribe(value => {
        this.router.navigate([], {
          queryParams: { sort: value, page: 0 },
          queryParamsHandling: 'merge',
        });
      }),
      this.searchControl.valueChanges.pipe(debounceTime(400)).subscribe(value => {
        this.router.navigate([], {
          queryParams: { search: value, page: 0 },
          queryParamsHandling: 'merge',
        });
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
